/* import __COLOCATED_TEMPLATE__ from './lsg-icon-selected-check.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

export const LsgIconSelectedCheckSizes = {
  MEDIUM: 'medium',
  LARGE: 'large'
};

/**
 * A check icon with background color.
 */
export default Component.extend({
  /**
   * Component props
   */
  tagName: 'span',
  classNames: ['LSG-c-selected-check'],
  classNameBindings: ['_isMedium:medium', '_isLarge:large'],

  /**
   * @param {String}    of type LsgIconSelectedCheckSizes.*
   */
  size: LsgIconSelectedCheckSizes.LARGE,

  /**
   * @type {Boolean}
   */
  _isLarge: computed('size', function() {
    return this.get('size') === LsgIconSelectedCheckSizes.LARGE;
  }),

  /**
   * @type {Boolean}
   */
  _isMedium: computed('size', function() {
    return this.get('size') === LsgIconSelectedCheckSizes.MEDIUM;
  }),
});
